<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.empCmsEntrance.entranceCode']">
              <a-input  v-model="queryParam.entranceCode"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.empCmsEntrance.entranceName']">
              <a-input  v-model="queryParam.entranceName"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.empCmsEntrance.status']">
              <!--<a-input placeholder="请输入入口名称" v-model="queryParam.entranceName"></a-input>-->
              <j-dict-select-tag type="list" v-model="queryParam.status" dictCode="emp_entrance_status"   allow-clear/>
            </a-form-item>
          </a-col>
          <!--<template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="状态">
                <j-switch placeholder="请选择状态（上架、下架）" v-model="queryParam.status" ></j-switch>
              </a-form-item>
            </a-col>
          </template>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('emp_cms_entrance')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      &lt;!&ndash; 高级查询区域 &ndash;&gt;
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="manager(record)" >{{language['emp.empCmsEntrance.managers']}}</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)" v-if="record.status==='N'">{{language['common.edit']}}</a>
          <a-divider type="vertical" v-if="record.status==='N'"/>
          <a @click="publish(record)" v-if="record.status==='N'">{{language['emp.entrance.status.publish']}}</a>
          <a @click="unPublish(record)" v-if="record.status==='Y'">{{language['emp.entrance.status.unpublish']}}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => deleteData(record)" v-if="record.status==='N'">
            <a>{{language['common.delete']}}</a>
          </a-popconfirm>
          <!--<a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>

      </a-table>
    </div>

    <emp-cms-entrance-modal ref="modalForm" @ok="modalFormOk"></emp-cms-entrance-modal>
    <emp-entrance-manager-modal ref="entranceManager"/>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpCmsEntranceModal from './modules/EmpCmsEntranceModal'
  import EmpEntranceManagerModal from './modules/EmpEntranceManagerModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction, getAction,postAction,putAction } from '@/api/manage'
  import moment from "moment";
  import DictList from "../../system/DictList";
  import { filterDictText } from '@/components/dict/JDictSelectUtil'
  import { getDictItemsFromCache } from '@/api/api'

  export default {
    name: 'EmpCmsEntranceList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      DictList,
      EmpCmsEntranceModal,
      EmpEntranceManagerModal
    },
    data () {
      return {
        description: 'emp_cms_entrance管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.$store.getters.language['emp.empCmsEntrance.entranceCode'],
            align:"center",
            dataIndex: 'entranceCode'
          },
          {
            title:this.$store.getters.language['emp.empCmsEntrance.entranceName'],
            align:"center",
            dataIndex: 'entranceName'
          },
          {
            title:this.$store.getters.language['emp.empCmsEntrance.publishTime'],
            align:"center",
            dataIndex: 'publishTime',
            customRender:function (text,r) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:this.$store.getters.language['emp.empCmsEntrance.status'],
            align:"center",
            dataIndex: 'status',
            customRender: (text) => (text ? filterDictText(this.statusDictList, text) : ''),
          },
          {
            title:this.$store.getters.language["emp.empCmsEntrance.userNumber"],
            align:"center",
            dataIndex: 'userNumber',
            // customRender: (text) => (text ? filterMultiDictText(this.dictOptions['status'], text) : ''),
          },
          {
            title:this.$store.getters.language["emp.empCmsEntrance.colNumber"],
            align:"center",
            dataIndex: 'colNumber',
            // customRender: (text) => (text ? filterMultiDictText(this.dictOptions['status'], text) : ''),
          },
          {
            title:this.$store.getters.language["emp.empCmsEntrance.applicationNumber"],
            align:"center",
            dataIndex: 'applicationNumber',
            // customRender: (text) => (text ? filterMultiDictText(this.dictOptions['status'], text) : ''),
          },
          /*{
            title:'说明',
            align:"center",
            dataIndex: 'description'
          },*/
          /*{
            title:'发布人/撤销人',
            align:"center",
            dataIndex: 'publisher'
          },*/

          /*{
            title:'排序',
            align:"center",
            dataIndex: 'sortNo'
          },
          {
            title:'刪除标示',
            align:"center",
            dataIndex: 'delFlag'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },*/
          {
            title: this.$store.getters.language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/hhemp/entrance/empcmsentrancesPage",
          delete: "/hhemp/entrance/empcmsentrance",
          deleteBatch: "/hhemp/entrance/empcmsentrance/batch",
          exportXlsUrl: "/hhemp/entrance/export-xls",
          importExcelUrl: "hhemp/entrance/import-excel",

        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    //   this.$set(this.dictOptions, 'status', [{text:'是',value:'Y'},{text:'否',value:'N'}])
    // this.getSuperFieldList();
      this.statusDictList = getDictItemsFromCache('emp_entrance_status');
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      moment,
      deleteData(record){
        record.delFlag = '1';
        this.updateData(record);
      },
      publish(record){
        record.status = "Y";
        record.publisher = this.$store.getters.userInfo.username
        record.publishTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.updateData(record)
      },
      unPublish(record){
        record.status = "N";
        record.publisher = this.$store.getters.userInfo.username
        record.publishTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.updateData(record)
      },
      updateData(record){
        putAction("/hhemp/entrance/empcmsentrance",record).then(res=>{
          if(res.success){
            this.$message.success(this.language['operationSuccess'])
            this.loadData(1)
          }else{
            this.$message.warn(this.language['common.errorContext'])
          }
        }).catch(error => {
          // reject(error)
          this.$message.warn(this.language['common.errorContext'])
        })
      },
      initDictConfig(){
      },
      manager(record){
        this.$refs.entranceManager.edit(record);
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'entranceCode',text:'入口编码',dictCode:''})
        fieldList.push({type:'string',value:'entranceName',text:'入口名称',dictCode:''})
        fieldList.push({type:'switch',value:'status',text:'状态（上架、下架）'})
        fieldList.push({type:'string',value:'description',text:'说明',dictCode:''})
        fieldList.push({type:'string',value:'publisher',text:'发布人/撤销人',dictCode:''})
        fieldList.push({type:'date',value:'publishTime',text:'发布时间/撤销时间'})
        fieldList.push({type:'int',value:'sortNo',text:'排序',dictCode:''})
        fieldList.push({type:'string',value:'delFlag',text:'刪除标示',dictCode:''})
        fieldList.push({type:'string',value:'remark',text:'备注',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
